module.exports = __webpack_public_path__ + "img/card-5.37813578.png";